// «Прямая речь» — design workspace screen (pwa-design@insights) on the
// engine payload: verbatim quotes with valence tags and dates. Hide
// (§2.8 rule 8) removes a quote forever.

import { useInsightsData } from '../model/useInsightsData'
import InsightsGate from './InsightsGate'
import InsightsEmpty from './InsightsEmpty'
import InsightsTabBar from './InsightsTabBar'
import HideButton from './HideButton'
import styles from './Speech.module.css'
import { BEFORE_PAYMENT_EMPTY } from './beforePaymentCopy'

const TONE_LABEL = { neg: 'Негативная эмоция', pos: 'Позитивная эмоция' } as const

function formatDate(iso: string) {
  const [year, month, day] = iso.split('-').map(Number)
  return new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long' }).format(new Date(year, month - 1, day))
}

export default function Speech() {
  const insights = useInsightsData()
  return (
    <>
      <InsightsGate insights={insights}>
        {insights.data && (
          <div className={styles.page}>
            <h1 className={styles.title}>Прямая речь</h1>
            <p className={styles.lead}>
              Здесь — темы, мысли и ситуации, которые чаще всего появлялись в твоих разговорах.
            </p>
            {insights.data.quotes.length === 0 ? (
              <InsightsEmpty
                title="Здесь пока пусто"
                text={insights.data.before_payment ? BEFORE_PAYMENT_EMPTY.quotes : 'Начни диалог с AI-психологом, и здесь появятся темы, мысли и ситуации, которые чаще всего встречаются в твоих разговорах.'}
              />
            ) : (
              <ul className={styles.list}>
                {insights.data.quotes.map((quote) => (
                  <li key={quote.id} className={styles.card}>
                    <div className={styles.meta}>
                      <span className={`${styles.tag} ${quote.valence === 'pos' ? styles.tagPositive : styles.tagNegative}`}>
                        {TONE_LABEL[quote.valence]}
                      </span>
                      {quote.date && <time className={styles.date} dateTime={quote.date}>{formatDate(quote.date)}</time>}
                      <HideButton
                        onHide={() => { void insights.hide('quotes', quote.id) }}
                        busy={insights.hiding === `quotes/${quote.id}`}
                      />
                    </div>
                    <p className={styles.quote}>«{quote.text}»</p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </InsightsGate>
      <InsightsTabBar />
    </>
  )
}
